import {
  business_days,
  every_x_days,
  every_x_months,
  every_x_months_last_day,
  every_x_months_last_working_day,
  every_x_weeks,
  every_x_years,
  Schedule,
  specific_dates,
  weekdays,
} from "../../../backend/types-v2";
import { localDateToJSDate } from "../../../utils";
import { FormData2 } from "./GenericTable";

export function recurrenceToForm(
  recurrence: Schedule,
): Pick<
  FormData2,
  | "scheduleType"
  | "frequency"
  | "interval"
  | "weekday"
  | "monthlyRule"
  | "startsFrom"
  | "endsOn"
  | "oneOffDates"
> {
  switch (recurrence.kind) {
    case every_x_months_last_working_day:
      return {
        scheduleType: "repeats",
        frequency: "monthly",
        interval: recurrence.interval,
        weekday: null,
        monthlyRule: { type: "last-working-day" },
        startsFrom: localDateToJSDate(recurrence.recurrenceAnchorDate),
        endsOn: null,
        oneOffDates: null,
      };

    case every_x_months_last_day:
      return {
        scheduleType: "repeats",
        frequency: "monthly",
        interval: recurrence.interval,
        weekday: null,
        monthlyRule: { type: "last-day" },
        startsFrom: localDateToJSDate(recurrence.recurrenceAnchorDate),
        endsOn: null,
        oneOffDates: null,
      };

    case every_x_months:
      return {
        scheduleType: "repeats",
        frequency: "monthly",
        interval: recurrence.interval,
        weekday: null,
        monthlyRule: {
          type: "fixed-day",
          day: recurrence.dayOfMonth.toString(),
        },
        startsFrom: localDateToJSDate(recurrence.recurrenceAnchorDate),
        endsOn: null,
        oneOffDates: null,
      };

    case specific_dates:
      return {
        scheduleType: "one-off",
        frequency: "specific-dates",
        interval: null,
        weekday: null,
        monthlyRule: null,
        startsFrom: null,
        endsOn: null,
        oneOffDates: recurrence.dates.map(localDateToJSDate),
      };

    case every_x_weeks: {
      return {
        scheduleType: "repeats",
        frequency: "weekly",
        interval: recurrence.interval,
        monthlyRule: null,
        weekday: recurrence.weekday.name(),
        startsFrom: null,
        endsOn: null,
        oneOffDates: null,
      };
    }

    case every_x_years: {
      console.log("recurrence:", recurrence);

      return {
        scheduleType: "repeats",
        frequency: "yearly",
        interval: recurrence.interval,
        weekday: null,
        monthlyRule: null,
        startsFrom: localDateToJSDate(recurrence.recurrenceAnchorDate),
        endsOn: null,
        oneOffDates: null,
      };
    }

    case business_days:
    case every_x_days:
    case weekdays:
    default:
      throw new Error(`Unsupported recurrence ${recurrence.kind}`);
  }
}
